var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"min-h-300"},[_c('video',{ref:"video",staticClass:"object-cover",attrs:{"poster":_vm.media.placholder,"autoplay":"","playsinline":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.media.video,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }